<template>
  <div class="dropdown">

    <a class="dropbtn">Cuenta</a>

    <div class="dropdown-content">
      <div v-if="currentUser" class="dropdown-identity">
        <p v-if="fullName" class="dropdown-identity__name">{{ fullName }}</p>
        <p class="dropdown-identity__email">{{ currentUser.username }}</p>
      </div>
      <router-link
      :to="'/cuenta/mi-cuenta'"
      >
        Mi cuenta
      </router-link>
      <router-link 
      :to="'/cuenta/cerrar-sesion'"
      >
        Cerrar sesión
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserDropdown',
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser
    },
    fullName: function () {
      if (!this.currentUser) return ''
      return ((this.currentUser.firstname || '') + ' ' + (this.currentUser.lastname || '')).trim()
    }
  },
  methods: {

  },
  mounted () {
    // Una sola carga por sesión; con la identidad ya en caché no se vuelve a pedir
    if (!this.currentUser) {
      this.$store.dispatch('fetchCurrentUser')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .dropdown {
//   align-self: flex-end;
//   padding: 0.8em 0.5em;
//   font-size: 0.9em;
// }

.dropdown {
  position: relative;
  display: inline-block;
}

.dropbtn {
  display: block;
  padding: 0.8em 0.5em;

  background-color: transparent;
  color: rgba(255, 255, 255, 0.82);

  font-size: 0.9em;
  font-weight: bold;
  text-decoration: none;

  cursor: pointer;
}

.dropbtn:hover {
  color: var(--color-white);
  border-bottom: 0.2em solid var(--color-orange);
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;

  min-width: 160px;

  background-color: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: 4px;

  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-identity {
  padding: 0.7em 1em 0.6em;
  border-bottom: 1px solid var(--color-line);

  &__name {
    margin: 0;
    font-size: 0.85em;
    font-weight: 600;
    color: var(--color-graphite);
  }

  &__email {
    margin: 0.1em 0 0;
    font-size: 0.78em;
    color: var(--color-ghost);
    word-break: break-all;
  }
}

.dropdown-content a {
  display: block;
  padding: 0.8em 1em;

  color: var(--color-graphite);
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;

  border-left: 3px solid transparent;
}

.dropdown-content a:hover {
  background-color: var(--color-mist);
  color: var(--color-navy);
  border-left-color: var(--color-orange);
}
</style>
